module.exports = __webpack_public_path__ + "static/itsm_ad_2-61f88278f162d114e057f1ac0a83ec50.png";